import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { mapDto } from '@shared/operators';
import { Course, CourseDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getCourse(id: string): Observable<Course> {
        return this.httpClient.get<CourseDto>(`library/courses/${id}`).pipe(
            mapDto((response) => new Course(response)),
            catchError((error: HttpErrorResponse) => {
                console.log(error);
                if (error.status === 403) {
                    throw new Error('no-access');
                }
                throw error;
            }),
        );
    }
}
